import { gql } from 'graphql-request'
import { useForm } from 'react-hook-form'
import { useState } from 'react'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"

import TextEditor from '@components/TextEditor'
// import Label from '@components/Label'
import { useMutation } from '@hooks/graphql'
import SaveButton from './SaveButton'

const UPDATE_TEXT_BLOCK_MUTATION = gql`
  mutation updateTextBlock($input: UpdateTextBlockInput!) {
    updateTextBlock(input: $input) {
      text {
        content
      }
      errors {
        message
      }
    }
  }
`

const TextForm = ({ id, content, refetch, uploadImage }) => {
  const form = useForm({
    defaultValues: { content },
    mode: 'onChange'
  })
  const [saving, setSaving] = useState(false)

  const { mutate: updateTextBlock, isLoading } = useMutation({
    gqlMutation: UPDATE_TEXT_BLOCK_MUTATION,
    onSuccess: () => {
      refetch()
      setSaving(false)
      form.reset(watchedValues)
    }
  })

  const watchedValues = form.watch()

  const handleSave = () => {
    setSaving(true)
    updateTextBlock({ input: { id, content: watchedValues.content } })
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(() => { })} className='w-full h-full flex flex-col'>
        <FormField
          control={form.control}
          name="content"
          render={({ field }) => (
            <FormItem className="flex flex-col h-full min-h-[80vh]">
              <FormLabel>Content</FormLabel>
              <FormControl className="flex-grow">
                <TextEditor.Container className='h-full max-h-full'>
                  <TextEditor
                    id='content'
                    uploadImage={uploadImage}
                    {...field}
                  />
                  <TextEditor.Actions>
                    <TextEditor.ToolbarToggle />
                  </TextEditor.Actions>
                </TextEditor.Container>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className='flex justify-end mt-5'>
          <SaveButton
            saving={saving}
            hasChanges={form.formState.isDirty}
            isLoading={isLoading}
            onSave={handleSave}
          />
        </div>
      </form>
    </Form>
  )
}

export default TextForm
